import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminManualReferralsApi } from '../services/adminManualReferralsApi';
import type {
  ManualReferralPrefill,
  ManualReferralResponse,
  UpdateManualReferralPayload,
} from '../types/manual-referral.type';

export const manualReferralEditKeys = {
  detail: (id: string) => ['admin', 'manual-referrals', 'edit', id] as const,
};

// Feature 117: edit-modal prefill. Always refetched on open (no stale prefill).
export const useManualReferralForEdit = (id: string | undefined, enabled: boolean) =>
  useQuery<ManualReferralPrefill, Error>({
    queryKey: manualReferralEditKeys.detail(id ?? ''),
    queryFn: () => adminManualReferralsApi.fetchManualReferralForEdit(id as string),
    enabled: enabled && Boolean(id),
    staleTime: 0,
  });

export const useUpdateManualReferral = () => {
  const queryClient = useQueryClient();

  return useMutation<
    ManualReferralResponse,
    Error,
    { id: string; payload: UpdateManualReferralPayload }
  >({
    mutationFn: ({ id, payload }) => adminManualReferralsApi.updateManualReferral(id, payload),
    onSuccess: (_data, { id }) => {
      // Billability/direction may change: KPIs and the prefill are stale.
      queryClient.invalidateQueries({ queryKey: ['analytics'] });
      queryClient.invalidateQueries({ queryKey: manualReferralEditKeys.detail(id) });
    },
  });
};
